<template>
  <section
    class="component-e32ed487"
    resmed-component-name="feature_animation_icon-line_text_2cta"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row">
          <div class="col-12 text-center">
            <div class="animation">
              <animation
                v-bind:animation="JSON.parse(acf.animation)"
              ></animation>
            </div>

            <div class="content">
              <!-- <eyebrow-icon v-if="eyebrowicon" v-bind:eyebrowicon="eyebrowicon"></eyebrow-icon> -->
              <div class="title">
                <h5>{{ acf.name }}</h5>
              </div>
              <h2>{{ acf.headline }}</h2>
              <p class="mb-4">{{ acf.description }}</p>

              <a
                v-bind:href="acf.cta.href"
                v-bind:target="acf.cta.target"
                class="ctaButton cta-pill filled-red icon right-arrow"
                >{{ acf.cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "component-e32ed487", // feature_animation_icon-line_text_2cta
  props: ["acf"],

  created() {
    this.setShowLinks(true);
  },
  methods: {
    ...mapMutations(['setShowLinks'])
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-e32ed487 {
  overflow: hidden;
}

.component {
  * {
    color: $cc-resmed-white;
  }

  .animation {
    margin-bottom: 2rem;
    transform: scale(1.9) translateY(2rem);

    @media (min-width: 576px) {
      transform: scale(1.8) translateY(3rem);
    }

    @media (min-width: 768px) {
      margin-bottom: 5rem;
      transform: scale(1.5) translateY(3rem);
    }

    @media (min-width: 992px) {
      margin-bottom: 0;
      transform: scale(1.2) translateY(4rem);
    }
  }

  .content {
    @media (min-width: 768px) {
      transform: translateY(-8rem);
      margin-bottom: -8rem;
    }

    h2 {
      margin-bottom: 1rem;

      @media (max-width: 767px) {
        // @extend %display; --> can’t @extend selectors across media queries.
        font-size: 2.438rem;
      }
    }

    .title {
      margin-bottom: 0.5rem;
      @extend %body-normal-bold;

      h5 {
        position: relative;
        margin-bottom: 0.25rem;

        @extend %eyebrow-center;
        &:before {
          background-color: $cc-resmed-white;
        }
      }
    }
  }
}
</style>
